import { ContratoRemanejoItem, Licitacao, Proponente } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Exercicio } from '../comum/exercicio.model';
import { Usuario } from '../comum/usuario.model';
import { Contrato } from './contrato.model';

export class ContratoRemanejo extends BaseResourceModel {
  constructor(
    public especie?: 'E' | 'R',
    public motivo?: string,
    public data_remanejo?: Date,
    public data_contabilizacao?: Date,
    public valor_servico?: number,
    public valor_material?: number,
    public valor_locacao?: number,
    public valor_total?: number,
    public contrato?: Contrato,
    public licitacao?: Licitacao,
    public proponente?: Proponente,
    public usuario?: Usuario,
    public exercicio?: Exercicio,
    public itens?: ContratoRemanejoItem[],
    public editavel?: boolean,
  ) {
    super();
  }
  static converteJson(json: any): ContratoRemanejo {
    return Object.assign(new ContratoRemanejo(), json);
  }
}
